import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Check, ArrowRight, ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { Reveal, WindReveal } from "@/components/Cinematic";

function List({ title, items, color }) {
  return (
    <div>
      <p className="text-sm uppercase tracking-[0.2em] mb-4" style={{ color }}>{title}</p>
      <ul className="space-y-3">
        {(items || []).map((it, i) => (
          <li key={i} className="flex items-start gap-3 text-[#3F3F2C]">
            <Check size={18} className="mt-1 shrink-0" style={{ color }} /> {it}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function ServiceDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  const [nf, setNf] = useState(false);

  useEffect(() => {
    setS(null); setNf(false);
    api.get(`/services/${slug}`).then((r) => {
      setS(r.data); document.title = `${r.data.title} — seedesign`;
    }).catch(() => setNf(true));
  }, [slug]);

  if (nf) return <div className="pt-40 pb-40 text-center font-serif text-3xl text-[#3F3F2C]">Service not found.</div>;
  if (!s) return <div className="pt-40 pb-40 text-center font-serif text-2xl text-[#81754B]">Loading…</div>;

  return (
    <div className="pt-28 pb-24" data-testid="service-detail">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <Link to="/services" className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-[#81754B] hover:text-[#66371B]">
          <ArrowLeft size={16} /> Services
        </Link>
        <p className="signature text-2xl text-[#81754B] mt-8">{s.tagline}</p>
        <h1 className="font-serif text-5xl sm:text-7xl tracking-tight text-[#3F3F2C] mt-2">
          <WindReveal text={s.title} />
        </h1>
        <p className="mt-6 max-w-2xl text-xl text-[#3F3F2C] leading-relaxed">{s.description}</p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-12">
          <Reveal><List title="What you get" items={s.deliverables} color="#66371B" /></Reveal>
          <Reveal delay={0.05}><List title="Ideal for" items={s.ideal_clients} color="#81754B" /></Reveal>
          <Reveal delay={0.1}><List title="Expected outcomes" items={s.expected_outcomes} color="#B4833D" /></Reveal>
        </div>

        <div className="mt-20 rounded-sm bg-[#3F3F2C] text-[#F7F1E1] p-10 lg:p-16 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <h2 className="font-serif text-3xl lg:text-4xl max-w-xl">Let&apos;s put {s.title.toLowerCase()} to work for your brand.</h2>
          <Link to="/contact" data-testid="service-cta" className="shrink-0 inline-flex items-center gap-2 rounded-full bg-[#66371B] px-8 py-4 hover:bg-[#3F3F2C] transition-colors">
            {s.cta_label || "Let's create"} <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </div>
  );
}
